import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./ErrorBoundary"
import { Provider } from "react-redux";
import { Store } from "./store/store";
import { BrowserRouter } from "react-router-dom";
import LoadingPage from "./components/custom/loadingpage/loading";
import "./style/custom.css";
import "./style/color.css";
import "./style/fonts.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
const Routers = lazy(() => import("./routes/router"));
root.render(
  <Suspense fallback={<LoadingPage />}>

    <Provider store={Store}>
      <ErrorBoundary>
        <BrowserRouter>
          <Routers />
        </BrowserRouter>
      </ErrorBoundary>
    </Provider>

  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
